export enum ResultDeliveryTimeEnum {
    END_OF_DAY = 1,
    WHEN_READY = 2,
}
